"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiResponseProperty = exports.ApiPropertyOptional = exports.createApiPropertyDecorator = exports.ApiProperty = void 0;
const helpers_1 = require("./helpers");
Object.defineProperty(exports, "ApiProperty", {
  enumerable: true,
  get: function () {
    return helpers_1.emptyDecorator;
  }
});
Object.defineProperty(exports, "createApiPropertyDecorator", {
  enumerable: true,
  get: function () {
    return helpers_1.emptyDecorator;
  }
});
Object.defineProperty(exports, "ApiPropertyOptional", {
  enumerable: true,
  get: function () {
    return helpers_1.emptyDecorator;
  }
});
Object.defineProperty(exports, "ApiResponseProperty", {
  enumerable: true,
  get: function () {
    return helpers_1.emptyDecorator;
  }
});
